module.exports = __webpack_public_path__ + "static/media/ss.c2a04382.png";